import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { chain, UpdateSession } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateCart";

addToChainAfter(chain, UpdateSession, props => {
    if ("additionalQueryStringParameters" in props.parameter) {
        if (props.updatedShipTo?.oneTimeAddress) {
            props.apiParameter.cart.properties = {
                ...props.apiParameter.cart.properties,
                oneTimeAddress: "true",
            };
        }
    }
});
